import PropTypes from 'prop-types';
import React from 'react';
import moment from 'moment';
import {FormattedMessage} from 'react-intl';

class DateRangeSelector extends React.Component {
  static propTypes = {
    selected: PropTypes.number,
    onSelectedItem: PropTypes.func.isRequired,
    dates: PropTypes.arrayOf(PropTypes.instanceOf(moment)).isRequired,
  };

  state = {};

  componentWillMount() {
    if (!this.props.selected && this.props.selected !== 0) {
      return;
    }

    this.setState({
      selected: this.props.selected,
    });
  }


  toggleChoice = (from, to, code, index) => {
    this.props.onSelectedItem(code, from, to);

    this.setState({
      selected: index,
    });
  };

  render() {
    return <div>
      <ul className="date-filter">
        {this.props.dates.map((date, i) =>
          <li key={i}
              onClick={this.toggleChoice.bind(this, date.from, date.to, date.code, i)}
              className={this.state.selected === i ? 'selected' : ''}>
            <a><FormattedMessage id={date.title}/></a>
          </li>
        )}
      </ul>
    </div>;
  }
}

export default DateRangeSelector;
